import axios from "axios";
import { BASE_API_URL } from "../constants/dropdown";

// Action Types
export const GET_LOAN_METRICS_REQUEST = "GET_LOAN_METRICS_REQUEST";
export const GET_LOAN_METRICS_SUCCESS = "GET_LOAN_METRICS_SUCCESS";
export const GET_LOAN_METRICS_FAIL = "GET_LOAN_METRICS_FAIL";

export const GET_LOAN_APPLICATIONS_REQUEST = "GET_LOAN_APPLICATIONS_REQUEST";
export const GET_LOAN_APPLICATIONS_SUCCESS = "GET_LOAN_APPLICATIONS_SUCCESS";
export const GET_LOAN_APPLICATIONS_FAIL = "GET_LOAN_APPLICATIONS_FAIL";

export const GET_LOAN_DETAIL_REQUEST = "GET_LOAN_DETAIL_REQUEST";
export const GET_LOAN_DETAIL_SUCCESS = "GET_LOAN_DETAIL_SUCCESS";
export const GET_LOAN_DETAIL_FAIL = "GET_LOAN_DETAIL_FAIL";

export const GET_LOAN_SCHEDULE_REQUEST = "GET_LOAN_SCHEDULE_REQUEST";
export const GET_LOAN_SCHEDULE_SUCCESS = "GET_LOAN_SCHEDULE_SUCCESS";
export const GET_LOAN_SCHEDULE_FAIL = "GET_LOAN_SCHEDULE_FAIL";

export const REVIEW_LOAN_REQUEST = "REVIEW_LOAN_REQUEST";
export const REVIEW_LOAN_SUCCESS = "REVIEW_LOAN_SUCCESS";
export const REVIEW_LOAN_FAIL = "REVIEW_LOAN_FAIL";
export const REVIEW_LOAN_RESET = "REVIEW_LOAN_RESET";

export const APPROVE_LOAN_REQUEST = "APPROVE_LOAN_REQUEST";
export const APPROVE_LOAN_SUCCESS = "APPROVE_LOAN_SUCCESS";
export const APPROVE_LOAN_FAIL = "APPROVE_LOAN_FAIL";
export const APPROVE_LOAN_RESET = "APPROVE_LOAN_RESET";

export const REJECT_LOAN_REQUEST = "REJECT_LOAN_REQUEST";
export const REJECT_LOAN_SUCCESS = "REJECT_LOAN_SUCCESS";
export const REJECT_LOAN_FAIL = "REJECT_LOAN_FAIL";
export const REJECT_LOAN_RESET = "REJECT_LOAN_RESET";

export const REQUEST_LOAN_INFO_REQUEST = "REQUEST_LOAN_INFO_REQUEST";
export const REQUEST_LOAN_INFO_SUCCESS = "REQUEST_LOAN_INFO_SUCCESS";
export const REQUEST_LOAN_INFO_FAIL = "REQUEST_LOAN_INFO_FAIL";
export const REQUEST_LOAN_INFO_RESET = "REQUEST_LOAN_INFO_RESET";

const getConfig = (getState) => {
  const {
    admin2faLogin: { userInfo },
  } = getState();
  const token = userInfo?.token?.access_token;
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
};

const buildQuery = (params) => {
  const valid = Object.entries(params).filter(
    ([_, v]) => v !== "" && v !== null && v !== undefined,
  );
  if (valid.length === 0) return "";
  return "?" + valid.map(([k, v]) => `${k}=${v}`).join("&");
};

export const fetchLoanMetrics =
  (fromDate = "", toDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_LOAN_METRICS_REQUEST });
      const config = getConfig(getState);
      const query = buildQuery({ fromDate, toDate });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/loans/metrics${query}`,
        config,
      );
      dispatch({ type: GET_LOAN_METRICS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_LOAN_METRICS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const fetchLoanApplications =
  (page = 1, pageSize = 50, fromDate = "", toDate = "", status = "", loanMode = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_LOAN_APPLICATIONS_REQUEST });
      const config = getConfig(getState);
      const query = buildQuery({ page, pageSize, fromDate, toDate, status, loanMode });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/loans${query}`,
        config,
      );
      dispatch({ type: GET_LOAN_APPLICATIONS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_LOAN_APPLICATIONS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const fetchLoanDetail = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_LOAN_DETAIL_REQUEST });
    const config = getConfig(getState);
    const { data } = await axios.get(
      `${BASE_API_URL}/admin/loans/${id}`,
      config,
    );
    dispatch({ type: GET_LOAN_DETAIL_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_LOAN_DETAIL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const fetchLoanSchedule = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_LOAN_SCHEDULE_REQUEST });
    const config = getConfig(getState);
    const { data } = await axios.get(
      `${BASE_API_URL}/admin/loans/${id}/schedule`,
      config,
    );
    dispatch({ type: GET_LOAN_SCHEDULE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_LOAN_SCHEDULE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const reviewLoanApplication = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: REVIEW_LOAN_REQUEST });
    const config = getConfig(getState);
    const { data } = await axios.post(
      `${BASE_API_URL}/admin/loans/${id}/review`,
      {},
      config,
    );
    dispatch({ type: REVIEW_LOAN_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const msg =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: REVIEW_LOAN_FAIL, payload: msg });
    throw new Error(msg);
  }
};

export const approveLoanApplication =
  (id, body = {}) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: APPROVE_LOAN_REQUEST });
      const config = getConfig(getState);
      const { data } = await axios.post(
        `${BASE_API_URL}/admin/loans/${id}/approve`,
        body,
        config,
      );
      dispatch({ type: APPROVE_LOAN_SUCCESS, payload: data });
      return data;
    } catch (error) {
      const msg =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: APPROVE_LOAN_FAIL, payload: msg });
      throw new Error(msg);
    }
  };

export const rejectLoanApplication =
  (id, reason) => async (dispatch, getState) => {
    try {
      dispatch({ type: REJECT_LOAN_REQUEST });
      const config = getConfig(getState);
      const { data } = await axios.post(
        `${BASE_API_URL}/admin/loans/${id}/reject`,
        { reason },
        config,
      );
      dispatch({ type: REJECT_LOAN_SUCCESS, payload: data });
      return data;
    } catch (error) {
      const msg =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: REJECT_LOAN_FAIL, payload: msg });
      throw new Error(msg);
    }
  };

export const requestLoanInfo = (id, note) => async (dispatch, getState) => {
  try {
    dispatch({ type: REQUEST_LOAN_INFO_REQUEST });
    const config = getConfig(getState);
    const { data } = await axios.post(
      `${BASE_API_URL}/admin/loans/${id}/request-info`,
      { note },
      config,
    );
    dispatch({ type: REQUEST_LOAN_INFO_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const msg =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: REQUEST_LOAN_INFO_FAIL, payload: msg });
    throw new Error(msg);
  }
};
